

import React from 'react';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import customStyles from "../../../../../assets/styles/customStyles";
import { QueryListHead } from "../../../../../config/constant";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { getColumnWidth, capitalizeFirstLetter, currencyFormat } from "../../../../../helpers/utilities";
import moment from 'moment';
import { EveryList } from "../../../../Sales/Setup/components/CustomersProductScheduling/Blocks/Every";

export const QueryListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, selected, handleSelected,
        loadMoreContent, loadMoreTask, form } = props;

    const isSelected = (name) => {
        const result = selected.indexOf(name) !== -1;
        return result;
    }

    const handleClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        handleSelected(newSelected);
    };

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={QueryListHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            selected={selected}
            details={details}
            onSelected={(value) => handleSelected(value)}
            width={true}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={QueryListHead?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={clsx('checkbox', classes.tablealign)} padding="checkbox">
                                                <Checkbox onClick={() => handleClick(data.id)} color="primary" checked={isSelected(data.id)} />
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 1) }}><span style={{ width: getColumnWidth(QueryListHead, 1) }}>{data?.customer?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 2) }}><span style={{ width: getColumnWidth(QueryListHead, 2) }}>{data?.product?.productName || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 3) }}><span style={{ width: getColumnWidth(QueryListHead, 3) }}>{data?.product?.productId || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 4) }}><span style={{ width: getColumnWidth(QueryListHead, 4) }}>{data?.workflow?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 5) }}><span style={{ width: getColumnWidth(QueryListHead, 5) }}>{capitalizeFirstLetter(data?.scheduleStatus || '---')}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 6) }}><span style={{ width: getColumnWidth(QueryListHead, 6) }}>{moment(form.dataOfSchedule).format('DD MMM YYYY')}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 7) }}><span style={{ width: getColumnWidth(QueryListHead, 7) }}>{data.quantity || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 8) }}><span style={{ width: getColumnWidth(QueryListHead, 8) }}>{data?.unit?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 9) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(QueryListHead, 9) }}>{data?.amount ? `₹ ${currencyFormat(data?.amount)}` : '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 10) }}><span style={{ width: getColumnWidth(QueryListHead, 10) }}>{data?.scheduleFrequency?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(QueryListHead, 10) }}>
                                                <div><EveryList classes={classes} data={data} /></div>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={QueryListHead.length}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are no results available for the searched query</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}